import { Component, type ReactNode } from 'react';

/** Failed view/chunk loads should leave an actionable screen. */
export class ViewBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override render() {
    if (this.state.failed) {
      return (
        <main className="route-loading" role="alert">
          <section className="card">
            <h1 className="card__title">This view couldn’t open</h1>
            <p>Reload Throughline to reconnect to your workspace.</p>
            <button
              type="button"
              className="button button--primary"
              onClick={() => window.location.reload()}
            >
              Reload workspace
            </button>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}
